// Display labels for API enum values. Each is passed through I18n.get where it is shown.
export const TERM_LABELS: Record<string, string> = {
    MONTHLY: 'Monthly',
    ANNUAL: 'Annual',
    TWO_YEARS: 'Two years',
    THREE_YEARS: 'Three years',
};
